import React, { useEffect } from "react";
import { Center } from "@/common/css";
import SingleSelect from "@/common/custom/SingleSelect";
import { MultiSelectFromAPI } from "@/common/custom/MultiSelectFromAPI";
import Button from "@/common/ui/Button";
import { LightText2 } from "@/common/ui/Text";
import { filterEmptyIcon, modalCloseIcon } from "@/dmr/common/SvgIcons";
import { employeeSelector, removeFilter, resetFilters, setFetchFilter, setFilter, updateFilter, addFilter } from "@/store/features/employeeSlice";
import { useAppDispatch } from "@/store/store";
import { TABLE } from "@/utils/constant/table.constant";
import { useSelector } from "react-redux";
import CustomDatePicker from "@/common/input/CustomDatePicker";
import CustomDateRangePicker from "@/common/input/CustomDateRangePicker";
import DurationInput from "@/common/input/DurationInput";
import { EMPTY_VALUE_FILTER_OPERATOR } from "@/utils/constant/global.constant";

const operators: any = {
  empId: [
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  empName: [
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  empEml: [
    // Email
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  status: [
    // Lookup
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals", isDefault: true },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  empTyp: [
    // Lookup
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals", isDefault: true },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  userTyp: [
    // Lookup
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals", isDefault: true },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  depart: [
    // Lookup
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals", isDefault: true },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  designation: [
    // Lookup
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals", isDefault: true },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  empPhone: [
    // Phone
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  strtDt: [
    // Date of Joining (date)
    { label: "On", value: "on", isDefault: true, fieldType: "date" },
    { label: "Before", value: "before", fieldType: "date" },
    { label: "After", value: "after", fieldType: "date" },
    { label: "Today", value: "today" },
    { label: "Between (from and to date)", value: "between", fieldType: "date-range" },
    { label: "Yesterday", value: "yesterday" },
    { label: "last month", value: "last_month" },
    { label: "last week", value: "last_week" },
    { label: "last year", value: "last_year" },
    { label: "this week", value: "this_week" },
    { label: "this month", value: "this_month" },
    { label: "this year", value: "this_year" },
    { label: "In the last", value: "in_the_last" },
    { label: "Due in", value: "due_in" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  reportingMngr: [
    // Profile, treat as text/single_select
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals", isDefault: true },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  panNo: [
    // PAN (text)
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  aadharNo: [
    // Aadhar (text)
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  createdBy: [
    // auto generated
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  updatedTs: [
    // Last Updated On (date-time)
    { label: "On", value: "on", isDefault: true, fieldType: "date" },
    { label: "Before", value: "before", fieldType: "date" },
    { label: "After", value: "after", fieldType: "date" },
    { label: "Today", value: "today" },
    { label: "Between (from and to date)", value: "between", fieldType: "date-range" },
    { label: "Yesterday", value: "yesterday" },
    { label: "last month", value: "last_month" },
    { label: "last week", value: "last_week" },
    { label: "last year", value: "last_year" },
    { label: "this week", value: "this_week" },
    { label: "this month", value: "this_month" },
    { label: "this year", value: "this_year" },
    { label: "In the last", value: "in_the_last" },
    { label: "Due in", value: "due_in" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  facebook: [
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  linkedin: [
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  instagram: [
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
  twitter: [
    { label: "Contains", value: "contains", isDefault: true },
    { label: "Doesn’t contain", value: "not_contains" },
    { label: "Is", value: "equals" },
    { label: "Isn't", value: "not_equals" },
    { label: "starts with", value: "startsWith" },
    { label: "ends with", value: "endsWith" },
    { label: "is empty", value: "is_empty" },
    { label: "is not empty", value: "is_not_empty" },
  ],
};
const FIELD_TYPE: any = {
  // Multi-select operators
  contains: "multi-select",
  not_contains: "multi-select",
  equals: "multi-select",
  not_equals: "multi-select",
  startsWith: "multi-select",
  endsWith: "multi-select",

  // Date operators
  on: "date",
  before: "date",
  after: "date",
  between: "date-range",

  // Date-time operators (for updatedTs field)
  on_datetime: "date-time",
  before_datetime: "date-time",
  after_datetime: "date-time",
  between_datetime: "date-range",

  // No input needed operators (empty values)
  is_empty: null,
  is_not_empty: null,
  today: null,
  yesterday: null,
  last_week: null,
  last_month: null,
  last_year: null,
  this_week: null,
  this_month: null,
  this_year: null,

  // Duration operators
  in_the_last: "duration",
  due_in: "duration",
};

const OPTIONS_API: any = {
  empId: "/employee/filter-option?option_key=empId",
  empName: "/employee/filter-option?option_key=empName",
  empEml: "/employee/filter-option?option_key=empEml",
  status: "/employee/option?option_key=emp-sts",
  empTyp: "/employee/option?option_key=employment_typ",
  depart: "/employee/option?option_key=depart",
  designation: "/employee/option?option_key=designatn",
  empPhone: "/employee/filter-option?option_key=empPhone",
  reportingMngr: "/employee/option?option_key=employees",
  panNo: "/employee/filter-option?option_key=panNo",
  aadharNo: "/employee/filter-option?option_key=aadharNo",
  createdBy: "/employee/option?option_key=employees",
  facebook: "/employee/filter-option?option_key=fb",
  instagram: "/employee/filter-option?option_key=ig",
  linkedin: "/employee/filter-option?option_key=li",
  twitter: "/employee/filter-option?option_key=tw",
  userTyp: "/employee/option?option_key=org-roles&&view=filter",
};

interface FilterProps {
  onClose?: (props?: any) => void;
  showAddFilterButton?: boolean;
}

const Filter: React.FC<FilterProps> = ({ showAddFilterButton = false, onClose }) => {
  const { filters, fetchFilters } = useSelector(employeeSelector);
  const dispatch = useAppDispatch();

  const handleFilterChange = (index: number, key: any, value: any) => {
    dispatch(updateFilter({ index, key, value }));
  };
  const filterCanBeSet = filters.every((f: any) => {
    if (!f.field?.value || !f.operator) {
      return false;
    }
    const operatorInfo = operators[f.field?.value]?.find((op: any) => op.value === f.operator?.value);
    const fieldType = operatorInfo?.fieldType || FIELD_TYPE[f.operator?.value];

    if (fieldType === null) {
      return true;
    }
    if (!Array.isArray(f.value) || f.value.length === 0) {
      return false;
    }

    if (fieldType === "duration") {
      return typeof f.value[0] === "object" && f.value[0] && f.value[0].amount && f.value[0].unit;
    } else if (fieldType === "date-range" || f.operator?.value === "between") {
      // For date range (Between from and to date), we need exactly 2 values
      return (
        f.value.length === 2 &&
        f.value[0] !== null &&
        f.value[0] !== undefined &&
        f.value[0] !== "" &&
        f.value[1] !== null &&
        f.value[1] !== undefined &&
        f.value[1] !== ""
      );
    } else {
      return f.value[0] !== null && f.value[0] !== undefined && f.value[0] !== "";
    }
  });

  const handleApplyFilter = () => {
    dispatch(setFetchFilter());
  };

  // Remove a filter
  const handleRemoveFilter = (index: number) => {
    dispatch(removeFilter(index));
  };

  useEffect(() => {
    if (fetchFilters.length > 0) {
      const newFilters = fetchFilters.map((filter: any) => {
        const operatorInfo = operators[filter.field?.value]?.find((op: any) => op.value === filter.operator);
        return {
          ...filter,
          operator: {
            label: operatorInfo?.label,
            value: operatorInfo?.value,
          },
        };
      });
      dispatch(setFilter(newFilters));
    }
  }, []);

  const handleAddFilter = () => {
    dispatch(addFilter());
  };

  // console.log("Filters Applied: ", filters);
  return (
    <div className="p-4 flex flex-col justify-between w-full !text-text-default bg-white" style={{ minHeight: '100%', display: 'flex' }}>
      {showAddFilterButton && (
        <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-lg font-semibold text-text-default">Filter</h2>
          <div className="flex items-center gap-3">
            {filters.length > 0 && (
              <button onClick={handleAddFilter} className="text-13 font-normal !leading-normal text-purple-500 hover:text-purple-700">
                Add filter
              </button>
            )}
            {onClose && (
              <button 
                onClick={onClose} 
                className="text-gray-500 hover:text-gray-700 p-1 hover:bg-gray-100 rounded transition-colors"
                aria-label="Close filter"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>
      )}
      <div className="w-full flex-1 overflow-y-auto" style={{ minHeight: 0, display: 'block' }}>
        {filters.length > 0 ? (
          filters.map((filter: any, index: number) => {
            // First check if the operator has a specific fieldType, otherwise use the general FIELD_TYPE mapping
            const operatorInfo = operators[filter.field?.value]?.find((op: any) => op.value === filter.operator?.value);
            const fieldType = operatorInfo?.fieldType || FIELD_TYPE[filter.operator?.value];
            // console.log("operator value:", filter.operator?.value, "fieldType:", fieldType);
            return filter?.field?.value ? (
              <div className=" flex justify-between items-start w-full" key={filter.field?.value + "-" + index}>
                <div key={index} className="flex flex-col gap-y-2 w-full min-w-[calc(100%-40px)] max-w-[calc(100%-40px)]">
                  <div className="flex gap-x-2 items-center w-full">
                    <LightText2 text={filter?.field?.label} className="font-medium whitespace-nowrap" />
                    <SingleSelect
                      options={operators[filter.field?.value]?.map((Operator: any) => ({ label: Operator.label, value: Operator.value })) || []}
                      placeholder="Select"
                      containerClass="w-fit flex item-center h-9"
                      textClassname="text-13"
                      onChange={(value) => handleFilterChange(index, "operator", value)}
                      selectedValue={filter.operator ?? operators[filter.field?.value]?.find((op: any) => op.isDefault)?.value ?? ""}
                      defaultValue={(() => {
                        const defaultOp = operators[filter.field?.value]?.find((f: any) => f?.isDefault);
                        return defaultOp ? { label: defaultOp.label, value: defaultOp.value } : undefined;
                      })()}
                      className="w-full text-13 leading-normal font-normal justify-between text-text-primary"
                      dropdownClassName="w-fit top-9 z-[60]"
                      listClassName="max-h-[200px] overflow-y-auto text-text-default bg-white "
                      activeClass="text-text-primary hover:bg-primaryOpacity-10 "
                    />
                  </div>
                  {(() => {
                    const operatorValue = filter?.operator?.value;

                    if (EMPTY_VALUE_FILTER_OPERATOR.includes(operatorValue)) {
                      return null;
                    }

                    if (fieldType === "duration") {
                      return (
                        <DurationInput
                          value={
                            filter.value?.[0]
                              ? {
                                  amount: filter.value[0].amount || 0,
                                  unit: filter.value[0].unit || "days",
                                }
                              : undefined
                          }
                          onChange={(value) => handleFilterChange(index, "value", [value])}
                          type={operatorValue === "in_the_last" ? "in_the_last" : "due_in"}
                        />
                      );
                    }

                    if (fieldType === "date-range") {
                      return (
                        <CustomDateRangePicker
                          value={
                            filter.value?.[0]
                              ? {
                                  startDate: filter.value[0],
                                  endDate: filter.value[1] || "",
                                }
                              : undefined
                          }
                          onChange={(value) => handleFilterChange(index, "value", [value.startDate, value.endDate])}
                          placeholder="Select date"
                          maxToday={false}
                        />
                      );
                    }

                    if (fieldType === "date") {
                      return (
                        <CustomDatePicker
                          value={filter.value?.[0] ?? ""}
                          onChange={(value) => handleFilterChange(index, "value", [value])}
                          placeholder="Select date"
                          maxToday={false}
                        />
                      );
                    }

                    if (fieldType === "date-time" || (fieldType === "date-range" && filter.field?.value === "updatedTs")) {
                      return (
                        <input
                          type="datetime-local"
                          className="border rounded px-2 py-1 text-sm"
                          onChange={(e) => handleFilterChange(index, "value", [e.target.value])}
                          value={filter.value?.[0] ?? ""}
                        />
                      );
                    }

                    if (fieldType === "multi-select") {
                      return (
                        <MultiSelectFromAPI
                          optionsApiUrl={OPTIONS_API[filter.field?.value]}
                          onValueChange={(value) => handleFilterChange(index, "value", value)}
                          defaultValue={filter.value ?? []}
                          placeholder="Select"
                          showSearch
                          maxCount={3}
                          key={filter.field?.value + "-multi-select"}
                        />
                      );
                    }

                    return null;
                  })()}
                </div>
                {/* Clear Filter for each field */}
                <button onClick={() => handleRemoveFilter(index)} className=" text-rose-500 text-10 hover:text-rose-700 pt-2">
                  Clear
                </button>
              </div>
            ) : (
              <div key={"empty-" + index} className="flex mb-4 flex-col mt-2">
                <Center className=" w-full justify-between pb-2">
                  <span className="text-13 !leading-normal font-medium ">Select filter field</span>
                  <button onClick={() => handleRemoveFilter(index)} className="text-gray-400 hover:text-gray-500" aria-label="Close">
                    {modalCloseIcon}
                  </button>
                </Center>
                {/* Field Dropdown for unfilled value */}
                <SingleSelect
                  isDarkDropdown={false}
                  options={TABLE.EMPLOYEE_TABLE_FIELDS.filter(
                    (field) => !field?.hideOnFilter && !filters.some((f: any) => f.field?.value === field.accessorKey)
                  ).map((field) => ({
                    label: field.label,
                    value: field.accessorKey,
                  }))}
                  placeholder="Select"
                  containerClass="w-full flex item-center h-9"
                  textClassname="text-13"
                  onChange={(value) => handleFilterChange(index, "field", value)}
                  selectedValue={filter.operator ? filter.operator : "Select"}
                  className="w-full text-13 leading-normal font-normal border-[1px] justify-between"
                  dropdownClassName="w-full top-9 "
                  listClassName="max-h-[200px] overflow-y-auto"
                  openOnRender
                  showSearch
                />
              </div>
            );
          })
        ) : (
          <div className=" flex w-full flex-col items-center h-full justify-center">
            <div className=" flex items-center flex-col gap-4 px-4 text-center">
              {filterEmptyIcon}
              <LightText2 text="Add filters to narrow the employees you want to see!" />
            </div>
          </div>
        )}
      </div>

      <div className="flex mt-4 justify-between flex-shrink-0 pt-4 border-t border-gray-200">
        <Button onClick={() => dispatch(resetFilters())} variant={"outline"} size="small" disabled={filters.length == 0}>
          Reset
        </Button>
        <Button onClick={handleApplyFilter} variant={"primary"} size="small" disabled={!filters.length || !filterCanBeSet}>
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Filter;
